import React, { useState, useEffect } from "react";
import Request from "../../../helpers/Request";
import { Modal } from "antd";
import { Space } from "antd";
import { Formik } from "formik";
import * as yup from "yup";
import { Form, Input, Select, Field } from "formik-antd";

const { TextArea } = Input;

const PluginModal = ({ setIsPluginModalVisible, setIsSuccessModalVisible, pluginName }) => {
  const initialValues = {
    offer: {
      shop_name: "",
      email: "",
      phone: "",
      plugin: pluginName,
    },
  };

  const businessFormSchema = yup.object().shape({
    offer: yup.object().shape({
      shop_name: yup.string().required("Privaloma"),
      email: yup
        .string()
        .max(50, "Max 50 simbolių")
        .matches(/^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@([0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)*|\[((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|IPv6:((((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){6}|::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){5}|[0-9A-Fa-f]{0,4}::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){4}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):)?(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){3}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,2}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){2}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,3}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,4}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,5}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,6}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)|(?!IPv6:)[0-9A-Za-z-]*[0-9A-Za-z]:[!-Z^-~]+)])$/, "Neteisingas el. pašto adresas")
        .required("Privaloma"),
      phone: yup.string().required("Privaloma"),
    }),
  });

  return (
    <>
      <Modal
        visible
        footer={false}
        onCancel={() => {
          setIsPluginModalVisible(false);
        }}
        maskClosable={false}
        width={640}
        style={{
          padding: 30
        }}
      >
        <div className="header-title-3" style={{ marginBottom: 20, maxWidth: 460, fontSize: 26 }}>
          {`Pateik savo kontaktinius duomenis ir mes su tavim susisieksime dėl ${pluginName} įskiepio per 1 darbo dieną`}
        </div>
        <Formik
          onSubmit={(
            data,
            { setSubmitting, setTouched, setErrors, setFieldValue }
          ) => {
            Request("/business_pages/plugin_offer_email", "POST", {
              body: data,
            }).then(() => {
              setIsPluginModalVisible(false);
              setIsSuccessModalVisible(true);
            });
          }}
          initialValues={initialValues}
          validationSchema={businessFormSchema}
        >
          {({
            isSubmitting,
            isValid,
            setFieldValue,
            errors,
            values,
            touched,
            submitForm,
            isInitialValid,
            validateForm,
            setSubmitting,
          }) => (
            <Form>
              <Form.Item name="offer[shop_name]">
                <Input
                  name="offer[shop_name]"
                  size="large"
                  style={{ height: "40px" }}
                  placeholder="Tavo el. parduotuvės pavadinimas"
                />
              </Form.Item>
              <Form.Item name="offer[phone]">
                <Input
                  name="offer[phone]"
                  size="large"
                  style={{ height: "40px" }}
                  placeholder="Kontaktinis telefono numeris"
                  onChange={(e) => {
                    const characters = e.target.value.split("");
                    let phone = characters
                      .filter((chr) => chr.match(/[0-9]/))
                      .join("");

                    if (characters[0] == "+") phone = characters[0] + phone;

                    setFieldValue("offer[phone]", phone);
                  }}
                />
              </Form.Item>
              <Form.Item name="offer[email]">
                <Input
                  name="offer[email]"
                  size="large"
                  style={{ height: "40px" }}
                  placeholder="Kontaktinis el. pašto adresas"
                />
              </Form.Item>
              <Form.Item name="submit">
                <button className="btn btn-primary-alsendo btn-lg btn-circle mt-4" type="submit">
                  {"Gauti pasiūlymą"}
                </button>
              </Form.Item>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default PluginModal;
